/**
 * RISKS-DOCUMENT-PREVIEW.ROUTE
 * Full-page preview of the Document Unique
 */
import { useNavigate, useSearchParams } from "react-router-dom"
import NavFocus from "@/nav/nav.focus"
import { useTranslation } from "react-i18next"
import RisksDocumentViewer from "../ui/RisksDocumentViewer"

export default function RisksDocumentPreviewRoute() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()

  const isShareMode = searchParams.has("establishmentId") && searchParams.has("organizationId")

  if (isShareMode) {
    return (
      <div className="w-full h-screen overflow-y-auto overflow-x-hidden pr-6">
        <RisksDocumentViewer onClose={() => navigate("/risks/document")} isShareMode />
      </div>
    )
  }

  return (
    <NavFocus onBack={() => navigate("/risks/document")} text={t("Document Unique")} isWithoutPadding>
      <RisksDocumentViewer onClose={() => navigate("/risks/document")} isShareMode={false} />
    </NavFocus>
  )
}
